import { inject } from "vue";

export const referenceWorkspaceKey = Symbol("referenceWorkspace");

export function useReferenceWorkspace() {
  const workspace = inject(referenceWorkspaceKey);
  if (!workspace)
    throw new Error("Reference sections require a reference workspace");
  return workspace;
}
